import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const New = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  document.title = "Post | Atrable";

  const createPost = () => {};

  return (
    <div style={{ minHeight: "100vh", textAlign: "center" }}>
      <div
        style={{
          backgroundColor: "whitesmoke",
          textAlign: "center",
          width: "75%",
          maxWidth: "800px",
          minWidth: "200px",
          margin: "auto",
          padding: "30px",
          borderRadius: "15px",
          marginTop: "50px",
        }}
      >
        <h1>Create a post</h1>
        <form onSubmit={createPost}>
          <input
            name="title"
            type="text"
            placeholder="Title"
            required
            // value={email}
            // onChange={onChange}
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "30px",
              width: "90%",
              maxWidth: "750px",
              minWidth: "100px",
              padding: "15px",
              borderRadius: "11.25px",
              border: "none",
              backgroundColor: "white",
            }}
          ></input>
          <textarea></textarea>
        </form>
        <div style={{ height: "30px" }} />
      </div>
      <h5>note for me: Project: "folder" of posts</h5>
    </div>
  );
};

export default New;
